'use client';
import type { CSSProperties, ReactElement } from 'react';
import { motion } from 'framer-motion';
import { pxToRem } from '@/theme/spacing';
import { zIndex } from '@/theme/zIndex';
import { dataEl, type DataElScope } from '@/utils/dataEl';
import { Cnonloggednavbar } from '../Cnonloggednavbar';
import { CSS_POINTER_EVENTS_AUTO, CSS_POINTER_EVENTS_NONE, NAVBAR_HEIGHT, } from './Cpagelayout.constants';
interface NonLoggedNavbarShellProps {
    dataElScope: DataElScope;
    isCenterModalOpen: boolean;
    isLandingPage: boolean;
    isScrolling: boolean;
    onLogoClick: () => void;
}
interface BuildNonLoggedWrapperStyleInput {
    isCenterModalOpen: boolean;
    isLandingPage: boolean;
}
interface BuildNonLoggedWrapperAnimationInput {
    isCenterModalOpen: boolean;
    isLandingPage: boolean;
    isScrolling: boolean;
}
interface CenterModalPointerEventsInput {
    isCenterModalOpen: boolean;
}
const NAVBAR_HIDDEN_ANIMATION = {
    opacity: 0,
    y: -8,
};
const NAVBAR_VISIBLE_ANIMATION = {
    opacity: 1,
    y: 0,
};
const LANDING_SCROLLING_ANIMATION = {
    opacity: 0.3,
    y: 0,
};
function getCenterModalPointerEvents({ isCenterModalOpen, }: CenterModalPointerEventsInput): 'none' | 'auto' {
    return isCenterModalOpen ? CSS_POINTER_EVENTS_NONE : CSS_POINTER_EVENTS_AUTO;
}
function buildNonLoggedWrapperStyle({ isCenterModalOpen, isLandingPage, }: BuildNonLoggedWrapperStyleInput): CSSProperties {
    const pointerEvents = getCenterModalPointerEvents({ isCenterModalOpen });
    if (!isLandingPage) {
        return {
            position: 'relative',
            zIndex: zIndex.navbar,
            pointerEvents,
        };
    }
    return {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: pxToRem(NAVBAR_HEIGHT),
        zIndex: zIndex.navbar,
        pointerEvents,
    };
}
function buildNonLoggedWrapperAnimation({ isCenterModalOpen, isLandingPage, isScrolling, }: BuildNonLoggedWrapperAnimationInput): {
    opacity: number;
    y: number;
} {
    if (isCenterModalOpen) {
        return NAVBAR_HIDDEN_ANIMATION;
    }
    if (isLandingPage && isScrolling) {
        return LANDING_SCROLLING_ANIMATION;
    }
    return NAVBAR_VISIBLE_ANIMATION;
}
export function NonLoggedNavbarShell({ dataElScope, isCenterModalOpen, isLandingPage, isScrolling, onLogoClick, }: NonLoggedNavbarShellProps): ReactElement {
    return (
      <motion.div data-el={dataEl(dataElScope, 'NonLoggedNavbarShell/Root')} initial={{ opacity: 0, y: -64 }} animate={buildNonLoggedWrapperAnimation({
            isCenterModalOpen,
            isLandingPage,
            isScrolling,
        })} exit={{ opacity: 0, y: -64 }} transition={{
            duration: 0.4,
            ease: [0.4, 0, 0.2, 1],
        }} style={buildNonLoggedWrapperStyle({
            isCenterModalOpen,
            isLandingPage,
        })}>
        <Cnonloggednavbar onLogoClick={onLogoClick}/>
      </motion.div>
    );
}
